(()=>{
  const SB='https://ouhtkmpgsmauyebwpqsj.supabase.co';
  const KEY='sb_publishable_CBwe_LRkZmEii18EiiUtuA_uxonULzb';

  function resetSelection(){
    const card=document.getElementById('cvgCard');
    if(card){
      card.hidden=true;
      card.classList.remove('cvg-carousel-active');
      const body=document.getElementById('cvgCardBody');
      if(body) body.innerHTML='';
    }
  }

  async function forceDestination(q){
    const query=String(q||'').trim();
    if(!query)return;
    resetSelection();

    try{
      const safe=query.replace(/[(),]/g,' ');
      const filter=encodeURIComponent(`municipio.ilike.*${safe}*,provincia.ilike.*${safe}*,nombre.ilike.*${safe}*`);
      const r=await fetch(`${SB}/rest/v1/spots?select=id,nombre,municipio,provincia,latitud,longitud&or=(${filter})&limit=500`,{
        headers:{apikey:KEY,Authorization:`Bearer ${KEY}`}
      });
      if(!r.ok)return;
      const rows=(await r.json()).filter(x=>Number.isFinite(Number(x.latitud))&&Number.isFinite(Number(x.longitud)));
      if(!rows.length)return;

      const nq=safe.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
      const exact=rows.filter(x=>String(x.municipio||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim()===nq);
      const pool=exact.length?exact:rows;

      const apply=()=>{
        const map=window.__caraviumCarouselMap;
        if(!map||!window.google?.maps)return;
        const bounds=new google.maps.LatLngBounds();
        pool.forEach(x=>bounds.extend({lat:Number(x.latitud),lng:Number(x.longitud)}));
        map.fitBounds(bounds,70);
        if(pool.length===1 && map.setZoom)map.setZoom(14);
      };

      apply();
      setTimeout(apply,350);
      setTimeout(apply,900);

      const status=document.getElementById('cvgStatus');
      if(status)status.textContent=`${pool.length} puntos encontrados en ${query}`;
    }catch(e){
      console.warn('CARAVIUM búsqueda',e);
    }
  }

  function bind(){
    const input=document.getElementById('cvgSearch');
    const button=document.getElementById('cvgSearchGo');
    if(!input||!button){setTimeout(bind,500);return;}

    input.addEventListener('input',()=>{if(input.value.trim())resetSelection();},{capture:true});
    input.addEventListener('keydown',e=>{
      if(e.key==='Enter'){
        resetSelection();
        setTimeout(()=>forceDestination(input.value),80);
      }
    },{capture:true});
    button.addEventListener('click',()=>{
      resetSelection();
      setTimeout(()=>forceDestination(input.value),80);
    },{capture:true});
    input.addEventListener('search',()=>{
      if(input.value.trim())setTimeout(()=>forceDestination(input.value),80);
    },{capture:true});
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',bind):bind();
})();

/* CARAVIUM GLOBAL ADD PLACE + MOBILE HEADER FIX V7 */
(()=>{
  const ADD_URL='/pages/comunidad-caravium?add=1';

  function addStyles(){
    if(document.getElementById('cv-add-place-fallback-style'))return;
    const s=document.createElement('style');
    s.id='cv-add-place-fallback-style';
    s.textContent=`
      .cv-add-place-fallback{display:inline-flex!important;align-items:center!important;gap:6px!important;padding:8px 13px!important;border-radius:999px!important;background:#20b9aa!important;color:#fff!important;font-weight:900!important;text-decoration:none!important;white-space:nowrap!important;margin-left:10px!important;line-height:1!important;height:auto!important;min-height:34px!important}
      .cv-add-place-fallback:hover{filter:brightness(.96);color:#fff!important}
      #cv-add-place-mobile-fallback{display:none!important}
      #cv-mobile-add-header{display:none}

      @media(max-width:749px){
        .cv-add-place-fallback,#cv-add-place-mobile-fallback{display:none!important}

        #header-group .header__row--top,
        #header-group .header__columns{position:relative!important}

        #cv-mobile-add-header{
          display:inline-flex!important;
          align-items:center!important;
          justify-content:center!important;
          position:absolute!important;
          left:50%!important;
          top:50%!important;
          transform:translate(-50%,-50%)!important;
          z-index:40!important;
          padding:8px 12px!important;
          border-radius:999px!important;
          background:#20b9aa!important;
          color:#fff!important;
          font-weight:900!important;
          font-size:13px!important;
          line-height:1!important;
          text-decoration:none!important;
          white-space:nowrap!important;
          box-shadow:0 3px 10px rgba(0,0,0,.18)!important;
        }

        #header-group .search-action,
        #header-group search-component,
        #header-group [data-testid="search-button"],
        #header-group [data-testid="cart-drawer-trigger"],
        #header-group .action__cart,
        #header-group .header-actions__cart-icon{
          display:none!important;
        }

        #header-group .menu-drawer,
        #header-group .menu-drawer__submenu,
        #header-group .menu-drawer__inner-submenu,
        #header-group .menu-drawer__navigation{
          background:#fff!important;
          color:#0D1B2A!important;
          --color-foreground:13 27 42!important;
          --color-foreground-rgb:13 27 42!important;
          --color-background:255 255 255!important;
          --color-background-rgb:255 255 255!important;
        }
        #header-group .menu-drawer a,
        #header-group .menu-drawer button,
        #header-group .menu-drawer summary,
        #header-group .menu-drawer .menu-drawer__menu-item,
        #header-group .menu-drawer .menu-drawer__menu-item-text,
        #header-group .menu-drawer .menu-drawer__title,
        #header-group .menu-drawer .close-button,
        #header-group .menu-drawer svg{
          color:#0D1B2A!important;
          fill:currentColor!important;
          opacity:1!important;
        }
        #header-group .menu-drawer__menu-item--active{
          color:#0D1B2A!important;
          font-weight:800!important;
        }
      }
    `;
    document.head.appendChild(s);
  }

  function findContacto(){
    const header=document.getElementById('header-group')||document;
    return [...header.querySelectorAll('a')].find(a=>String(a.textContent||'').trim().toLowerCase()==='contacto')||null;
  }

  function ensureDesktop(){
    if(document.querySelector('.cv-add-place-fallback'))return;
    const contacto=findContacto();
    if(!contacto)return;

    const a=document.createElement('a');
    a.href=ADD_URL;
    a.className='cv-add-place-fallback';
    a.setAttribute('aria-label','Añadir un lugar a CARAVIUM');
    a.textContent='➕ Añadir lugar';

    const parent=contacto.closest('li');
    if(parent){
      const li=document.createElement('li');
      li.className=parent.className||'menu-list__list-item';
      li.setAttribute('data-cv-add-place','1');
      li.appendChild(a);
      parent.insertAdjacentElement('afterend',li);
    }else{
      contacto.insertAdjacentElement('afterend',a);
    }
  }

  function ensureMobileHeader(){
    const old=document.getElementById('cv-add-place-mobile-fallback');
    if(old)old.remove();
    if(window.innerWidth>749)return;
    if(document.getElementById('cv-mobile-add-header'))return;

    const row=document.querySelector('#header-group .header__row--top .header__columns')||document.querySelector('#header-group .header__row--top');
    if(!row)return;

    const a=document.createElement('a');
    a.id='cv-mobile-add-header';
    a.href=ADD_URL;
    a.setAttribute('aria-label','Añadir un lugar a CARAVIUM');
    a.textContent='➕ Añadir lugar';
    row.appendChild(a);
  }

  function ensureMobileHome(){
    if(window.innerWidth>749)return;
    const menu=document.querySelector('#header-group .menu-drawer .menu-drawer__menu.has-submenu');
    if(!menu)return;

    const current=document.getElementById('HeaderDrawer-inicio-caravium')||menu.querySelector('[data-cv-mobile-home="1"]');
    if(current){
      const li=current.closest?current.closest('li'):current;
      if(li&&menu.firstElementChild!==li)menu.insertBefore(li,menu.firstElementChild);
      return;
    }

    const li=document.createElement('li');
    li.setAttribute('data-cv-mobile-home','1');
    li.className='menu-drawer__list-item--flat';
    li.style.setProperty('--menu-drawer-animation-index','0');

    const a=document.createElement('a');
    a.href='/';
    a.id='HeaderDrawer-inicio-caravium';
    a.className='menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element';
    a.innerHTML='<span class="menu-drawer__menu-item-text wrap-text">Inicio</span>';
    li.appendChild(a);
    menu.insertBefore(li,menu.firstElementChild);
  }

  function removeExtraStickyAddPlace(){
    if(window.innerWidth>749)return;
    const header=document.getElementById('header-group');
    [...document.querySelectorAll('a,button')].forEach(el=>{
      if(el.id==='cv-mobile-add-header')return;
      if(header&&header.contains(el))return;
      const text=String(el.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      if(!text.includes('añadir lugar'))return;
      let pos='';
      try{pos=getComputedStyle(el).position;}catch(e){}
      if(pos==='fixed'||pos==='sticky'||el.id==='cv-add-place-mobile-fallback')el.remove();
    });
  }

  function ensureMobile(){
    ensureMobileHeader();
    ensureMobileHome();
    removeExtraStickyAddPlace();
  }

  function init(){
    addStyles();
    ensureDesktop();
    ensureMobile();

    const h=document.getElementById('header-group');
    if(h)new MutationObserver(()=>{ensureDesktop();ensureMobile();}).observe(h,{childList:true,subtree:true});

    const bodyObserver=new MutationObserver(()=>{ensureMobileHome();removeExtraStickyAddPlace();});
    bodyObserver.observe(document.body,{childList:true,subtree:true});

    [100,250,500,900,1500,3000,5000].forEach(ms=>setTimeout(()=>{ensureDesktop();ensureMobile();},ms));
    window.addEventListener('resize',ensureMobile,{passive:true});
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();

/* CARAVIUM ACTIVE NAV V2 */
(()=>{
  function addActiveStyles(){
    let s=document.getElementById('cv-active-nav-style');
    if(!s){
      s=document.createElement('style');
      s.id='cv-active-nav-style';
      document.head.appendChild(s);
    }
    s.textContent=`
      @media(min-width:750px){
        #header-group .menu-list__link.cv-nav-current{
          color:#ffffff!important;
          background:#159f94!important;
          font-weight:900!important;
          border-radius:999px!important;
          padding:6px 10px!important;
          margin:0 2px!important;
          text-decoration:none!important;
          box-shadow:none!important;
        }
        #header-group .menu-list__link.cv-nav-current::before,
        #header-group .menu-list__link.cv-nav-current::after{display:none!important;content:none!important}
      }
      @media(max-width:749px){
        #header-group .menu-drawer li.cv-nav-current-parent{
          background:#e8fbf8!important;
          border-left:5px solid #20b9aa!important;
          border-radius:0 12px 12px 0!important;
          margin:3px 8px 3px 0!important;
        }
        #header-group .menu-drawer li.cv-nav-current-parent > a,
        #header-group .menu-drawer li.cv-nav-current-parent > summary,
        #header-group .menu-drawer .menu-drawer__menu-item.cv-nav-current{
          background:#e8fbf8!important;
          color:#087d73!important;
          font-weight:900!important;
          border:0!important;
          border-radius:0 12px 12px 0!important;
          opacity:1!important;
        }
        #header-group .menu-drawer li.cv-nav-current-parent .menu-drawer__menu-item-text,
        #header-group .menu-drawer .menu-drawer__menu-item.cv-nav-current .menu-drawer__menu-item-text{
          color:#087d73!important;
          font-weight:900!important;
        }
      }
    `;
  }

  function normalizedPath(value){
    try{return new URL(value,location.origin).pathname.replace(/\/+$/,'')||'/';}
    catch(e){return '';}
  }

  function sectionKey(path){
    if(path==='/')return 'inicio';
    if(path.includes('/pages/pernoctar')||path.includes('/apps/pernoctar/'))return 'pernoctar';
    if(path.includes('/pages/planificar'))return 'planificar';
    if(path.includes('/pages/guias'))return 'guias';
    if(path.includes('/pages/mi-vehiculo'))return 'mi-vehiculo';
    if(path.includes('/pages/contact'))return 'contacto';
    if(path.includes('/pages/comunidad-caravium')||path.includes('/pages/pagina-comunidad-caravium'))return 'comunidad';
    return '';
  }

  function linkKey(a){
    const path=normalizedPath(a.href||'');
    const text=String(a.textContent||'').trim().toLowerCase();
    if(path==='/')return 'inicio';
    if(path.includes('/pages/pernoctar')||text==='pernoctar')return 'pernoctar';
    if(path.includes('/pages/planificar')||text==='planificar')return 'planificar';
    if(path.includes('/pages/guias')||text==='guías'||text==='guias')return 'guias';
    if(path.includes('/pages/mi-vehiculo')||text==='mi vehículo'||text==='mi vehiculo')return 'mi-vehiculo';
    if(path.includes('/pages/contact')||text==='contacto')return 'contacto';
    if(path.includes('/pages/comunidad-caravium')||text==='comunidad')return 'comunidad';
    return '';
  }

  function markActive(){
    addActiveStyles();
    const current=sectionKey(normalizedPath(location.href));
    const header=document.getElementById('header-group');
    if(!header)return;

    header.querySelectorAll('.cv-nav-current-parent').forEach(el=>el.classList.remove('cv-nav-current-parent'));
    header.querySelectorAll('a').forEach(a=>{
      a.classList.remove('cv-nav-current');
      a.removeAttribute('data-cv-current');
      if(current&&linkKey(a)===current){
        a.classList.add('cv-nav-current');
        a.setAttribute('data-cv-current','1');
        a.setAttribute('aria-current','page');
        const li=a.closest('li');
        if(li)li.classList.add('cv-nav-current-parent');
      }else if(a.getAttribute('aria-current')==='page'){
        a.removeAttribute('aria-current');
      }
    });
  }

  function init(){
    markActive();
    const h=document.getElementById('header-group');
    if(h)new MutationObserver(()=>setTimeout(markActive,0)).observe(h,{childList:true,subtree:true});
    [150,400,900,1600,3000].forEach(ms=>setTimeout(markActive,ms));
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();